import { LicenseContent } from './licenseContent';
import { LicenseContentENUS } from './licenseContent.en-us';
import { LicenseContentES } from './licenseContent.es';
import { LicenseContentDE } from './licenseContent.de';
import { LicenseContentFR } from './licenseContent.fr';
import { LicenseContentNLNL } from './licenseContent.nl-nl';
import { LicenseContentNL } from './licenseContent.nl';

export class LicenseSelector {
  public static en = LicenseContent.licenseContent;
  public static enus = LicenseContentENUS.licenseContentENUS;
  public static es = LicenseContentES.licenseContentES;
  public static de = LicenseContentDE.licenseContentDE;
  public static fr = LicenseContentFR.licenseContentFR;
  public static nlnl = LicenseContentNLNL.licenseContentNLNL;
  public static nl = LicenseContentNL.licenseContentNL;
}

export function LicenseSelectingFunction(culture: string) {
    const selectorKey: string = culture.replace('-', '').toLowerCase();
    let selectedLicenseContent = LicenseSelector[selectorKey];
    if (selectedLicenseContent == null) {
        const cultureParts = culture.split('-');
        selectedLicenseContent = LicenseSelector[cultureParts[0].toLowerCase()];
        if (selectedLicenseContent == null) {
            selectedLicenseContent = LicenseContent.licenseContent;
        }
    }
    return selectedLicenseContent;
}

